import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as ArrowDown } from "../../../assets/images/icon-arrow-down.svg";
import { ReactComponent as ArrowUp } from "../../../assets/images/icon-arrow-up.svg";
import { ReactComponent as CloseIcon } from "../../../assets/images/trash_red.svg";
import useCustomStyles from "../../../hooks/useCustomStyles";
import { dropdownStyles } from "../../../assets/styles/ClientsStyles/dropdownStyles";
import { useSelector } from "react-redux";
import { selectState } from "../../../store/slices/themeSlice";

interface Option {
  key: string;
  value: string;
}

interface DropDownProps {
  options: Option[];
  initialState: string;
  handleSelect: (value: string) => void;
}

const Dropdown: React.FC<DropDownProps> = ({
  options,
  handleSelect,
  initialState,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialState);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(dropdownStyles, theme);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOptionSelect = (item: Option) => {
    setSelectedOption(item.value);
    handleSelect(item.value);
    setShowDropdown(false);
  };

  const handleResetSelection = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedOption(initialState);
    handleSelect(initialState);
  };

  return (
    <div ref={dropdownRef} className={classes.root}>
      <button
        onClick={() => setShowDropdown(!showDropdown)}
        className={`${classes.button} ${showDropdown ? "open" : ""}`}
      >
        <span className={classes.buttonText}>{selectedOption}</span>
        <span className={classes.iconContainer}>
          {selectedOption !== initialState ? (
            <CloseIcon
              width={15}
              height={15}
              onClick={handleResetSelection}
              style={{ cursor: "pointer" }}
            />
          ) : showDropdown ? (
            <ArrowUp width={15} height={15} />
          ) : (
            <ArrowDown width={15} height={15} />
          )}
        </span>
      </button>

      {showDropdown && options.length > 0 && (
        <div className={classes.dropdownMenu}>
          {options.map((item) => (
            <div
              key={item.key}
              className={classes.dropdownItem}
              onClick={() => handleOptionSelect(item)}
            >
              {item.value}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
